import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import UsersRequests from "services/users";
import AdminLogHeading from "./AdminLogTableHeading";
import AdminLogTableItem from "./AdminLogTableItem";

const AdminlogTable = ({ searchMode, searchInput, selectedAdminLogDB }) => {
  const dispatch = useDispatch();
  const { adminLogs, adminLogsCurrentPage, adminLogsTotalPages } = useSelector(
    ({ users }) => users
  );

  useEffect(() => {
    if (searchMode) {
      dispatch(UsersRequests.getAdminLogs(1, searchInput, selectedAdminLogDB));
    } else {
      dispatch(UsersRequests.getAdminLogs(1, "", selectedAdminLogDB));
    }
  }, [searchInput, searchMode, selectedAdminLogDB]);
  const handleChangePagination = (_, value) => {
    if (searchMode) {
      dispatch(
        UsersRequests.getAdminLogs(value, searchInput, selectedAdminLogDB)
      );
    } else {
      dispatch(UsersRequests.getAdminLogs(value, "", selectedAdminLogDB));
    }
  };

  return (
    <div className="Cmt-table-responsive">
      {adminLogs &&
        (adminLogs.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <AdminLogHeading />
            </TableHead>
            <TableBody>
              {adminLogs.map((item) => (
                <AdminLogTableItem data={item} key={item._id} />
              ))}
            </TableBody>
          </Table>
        ))}
      {adminLogs.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={adminLogsTotalPages}
            color="primary"
            page={adminLogsCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default AdminlogTable;
